import { makeStyles, Link } from "@fluentui/react-components";
import { ArrowSquareUpRightRegular } from "@fluentui/react-icons";

const useStyles = makeStyles({
    linkWithIcon: {
        display: "inline-flex",
        alignItems: "center",
        gap: "0.25rem"
    }
});

export default function LinkWithIcon(
    {
        href,
        text,
        newTab
    }: {
        href: string,
        text: string,
        newTab?: boolean
    }
) {
    const styles = useStyles();

    return (
        <>
            <Link href={href} className={styles.linkWithIcon} target={newTab ? "_blank" : "_self"}>
                {text} <ArrowSquareUpRightRegular />
            </Link>
        </>
    );
}